import { render } from "./Pagamenti.vue?vue&type=template&id=379b4b0c"
import script from "./Pagamenti.vue?vue&type=script&lang=js"
export * from "./Pagamenti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__